import { render, staticRenderFns } from "./dropdownSimple.vue?vue&type=template&id=8e2cca94"
import script from "./dropdownSimple.js?vue&type=script&lang=js&external"
export * from "./dropdownSimple.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports